import { cva } from "class-variance-authority";
import { cn } from "../../../client/cn";
import { formColors } from "../../../shared/colors";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: boolean;
  disabled?: boolean;
}

const inputVariants = cva(
  "w-full rounded-md px-3 py-2 shadow-xs transition-colors duration-200 focus:outline-hidden focus:ring-2 caret-primary dark:border-strokedark dark:bg-boxdark",
  {
    variants: {
      state: {
        default: `${formColors.input.base} ${formColors.input.focus} dark:text-white`,
        error: `${formColors.input.error} dark:text-white`,
        disabled: formColors.input.disabled,
      },
    },
    defaultVariants: {
      state: "default",
    },
  },
);

export function Input({
  label,
  error = false,
  disabled = false,
  className = "",
  ...props
}: InputProps) {
  const state = disabled ? "disabled" : error ? "error" : "default";

  return (
    <div>
      {label && (
        <label className="mb-2 block text-sm font-medium text-text-primary dark:text-bodydark">
          {label}
        </label>
      )}
      <input
        className={cn(inputVariants({ state }), className)}
        disabled={disabled}
        aria-invalid={error || undefined}
        {...props}
      />
    </div>
  );
}
